export default __webpack_public_path__ + "static/media/3star.8c3f41ff.png";